var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#ffffff"}},[_c('el-carousel',{staticClass:"image-box",attrs:{"height":"600px"}},_vm._l((_vm.imgs),function(item,index){return _c('el-carousel-item',{key:index,staticStyle:{"text-align":"center"}},[_c('el-image',{staticClass:"image",staticStyle:{"height":"100%"},attrs:{"src":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }